import ImgDialog from './imgDialog.vue'
import PopupImgDialog from './popupImgDialog.vue'
export { ImgDialog, PopupImgDialog }



// WEBPACK FOOTER //
// ./src/components/imgDialog/index.js